/**
 * @generated SignedSource<<e252c100cc392ccfccc696128b87b8b2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ResendClientInviteInput = {
  clientMutationId?: string | null | undefined;
  id: string;
};
export type ClientPendingMenuResendMutation$variables = {
  input: ResendClientInviteInput;
};
export type ClientPendingMenuResendMutation$data = {
  readonly resendClientInvite: {
    readonly clientMutationId: string | null | undefined;
  } | null | undefined;
};
export type ClientPendingMenuResendMutation = {
  response: ClientPendingMenuResendMutation$data;
  variables: ClientPendingMenuResendMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ResendClientInvitePayload",
    "kind": "LinkedField",
    "name": "resendClientInvite",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ClientPendingMenuResendMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ClientPendingMenuResendMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "718d6f218630f1ecda3ab2f1f2adfcd7",
    "id": null,
    "metadata": {},
    "name": "ClientPendingMenuResendMutation",
    "operationKind": "mutation",
    "text": "mutation ClientPendingMenuResendMutation(\n  $input: ResendClientInviteInput!\n) {\n  resendClientInvite(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();

(node as any).hash = "98f89640a59a86bf836158b0ec08100c";

export default node;
